import React from "react";
import { Box, Typography } from "@mui/material";

const Support = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h4" sx={{ mb: 2 }}>Help & Support</Typography>
    <Typography>Contact support, find help articles, or submit a request here.</Typography>
  </Box>
);

export default Support;
